import React from 'react';

import { MAILING_ADDRESS } from '../../../globals';
import { InfoPageWrapper } from '../../shared/infoPageWrapper';
import MaxWidth from '../../shared/MaxWidth';
import * as S from './Legal.styles';

export const LegalPageContent: React.FC = () => {
  return (
    <>
      <InfoPageWrapper>
        <MaxWidth>
          <S.Content>
            <S.TextBox>
              <S.Caption>Legal</S.Caption>
            </S.TextBox>
            <S.Section>
              <S.SectionHeader>Agent for DMCA Notification</S.SectionHeader>
              <p>
                {MAILING_ADDRESS.split('\n').map((item, i) => (
                  <span key={i}>
                    {item}
                    <br />
                  </span>
                ))}
              </p>
            </S.Section>

            <S.Section>
              <S.SectionHeader>Patents</S.SectionHeader>
              <p>
                The technology used in Brain.fm is protected under the following patents:
                <br />
                U.S. Patent 7,674,224; U.S. Patent 10,653,857; U.S. Patent 11,205,414; U.S. Patent
                11,392,345; U.S. Patent 11,532,298; U.S. Patent 11,816,392; U.S. Patent 11,966,661
              </p>
            </S.Section>
            <S.Section>
              <S.SectionHeader>Copyright</S.SectionHeader>
              <p>
                All rights reserved. All content included in this website, such as documentation,
                independent research, text, personal quotes, graphics, photographs, logos, button
                icons, images, audio files, video files, digital downloads, data compilations, and
                software, is the property of the Brain.fm and are protected by United States and
                international copyright laws. Unless otherwise noted, no part of this site may be
                reproduced, reverse engineered, stored in a retrieval system, redistributed, sourced
                for file sharing or transmitted, in any form or by any means, electronic, printing,
                mechanical, photocopying, recording, or otherwise, without the specific, prior
                written permission of Brain.fm
              </p>
              <p>
                Please understand that even if credit is given with publication (including
                electronic publication) of a copyrighted material, it remains a copyright violation
                if the material has been used without express permission of the copyright owner.
              </p>
            </S.Section>
          </S.Content>
        </MaxWidth>
      </InfoPageWrapper>
    </>
  );
};
